import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function PainSection() {
  const pains = ["no estás 'pensando mal'", "no estás 'siendo débil'", "no estás 'dramatizando'"];
  return <section className="py-24 px-4 bg-[var(--bg-primary)]" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <SectionWrapper data-id="element-107">
          <h2 className="text-3xl md:text-5xl mb-8 text-[var(--text-primary)]" data-id="element-108">
            Si te despiertas a las 3AM… <br data-id="element-109" />
            <span className="text-[var(--text-muted)]" data-id="element-110">no es tu culpa.</span>
          </h2>

          <p className="text-lg md:text-xl text-[var(--text-secondary)] mb-8 leading-relaxed" data-id="element-111">
            Necesitas saber qué hacer. Porque a esa hora:
          </p>
        </SectionWrapper>

        <ul className="space-y-4 mb-12" data-id="element-112">
          {pains.map((pain, index) => <SectionWrapper key={index} delay={0.1 + index * 0.1} data-id="element-113">
              <li className="flex items-center text-xl md:text-2xl text-[var(--red-soft)] font-serif italic" data-id="element-114">
                <span className="mr-4 text-[var(--text-muted)]" data-id="element-115">—</span>
                {pain}
              </li>
            </SectionWrapper>)}
        </ul>

        <SectionWrapper delay={0.4} data-id="element-116">
          <div className="bg-[var(--bg-card)] p-8 md:p-10 rounded-2xl border border-[var(--bg-card-hover)] shadow-xl" data-id="element-117">
            <p className="text-xl md:text-2xl text-[var(--text-primary)] leading-relaxed mb-6" data-id="element-118">
              Estás en un circuito: <br data-id="element-119" />
              <span className="text-[var(--accent-amber)]" data-id="element-120">
                cuerpo activado + mente acelerada + miedo a mañana.
              </span>
            </p>

            <p className="text-lg text-[var(--text-secondary)] leading-relaxed" data-id="element-121">
              Y si cada vez improvisas… el cerebro aprende que 3AM = peligro.
              <br data-id="element-122" />
              <br data-id="element-123" />
              Resultado: te despiertas más fácil y vuelves a dormir más difícil.
            </p>
          </div>
        </SectionWrapper>
      </div>
    </section>;
}